import { stringify } from 'qs';

export function stringifyQueryString(params?: object | null): string {
    return stringify(params ?? {}, { arrayFormat: 'indices', skipNulls: true });
}

export const randomString = (length: number = 6): string => {
    return [...Array(length)].map(() => Math.random().toString(36)[2]).join('');
};

export const countryEmoji = (isoCountry: string): string => {
    return isoCountry
        .toUpperCase()
        .split('')
        .map((char) => String.fromCodePoint(char.charCodeAt(0) + 0x1f1a5))
        .join('');
};

export const firstToUpperCase = (string: unknown): string => {
    if (typeof string !== 'string') {
        throw new Error(`Provided value "${string}" is not a valid string`);
    }

    return String(string).charAt(0).toUpperCase() + String(string).slice(1);
};

export const isNotEmpty = (string: unknown): boolean => {
    return typeof string === 'string' && string.trim() !== '';
};
